import { AnimatePresence } from "framer-motion";
import { CaretDown, CaretUp } from "phosphor-react";
import React, { useEffect, useRef, useState } from "react";
import {
  DataBreach,
  InformationAboutOthers,
  Introduction,
  KindOfPersonalData,
  LawfulBasis,
  RetainYourPersonalData,
  ShareYourPersonalData,
  SourceOfPersonalData,
  StorePersonalData,
  Unsubscribe,
  UseYourPersonalData,
  YourConsent,
  YourPrivacyRight,
} from "./PrivacyContents";
import { useSelector } from "react-redux";

let contentList = [
  {
    title: "1. Introduction",
    component: <Introduction />,
    id: "Introduction",
  },
  {
    title: "2. Your Consent",
    component: <YourConsent />,
    id: "YourConsent",
  },
  {
    title: "3. Your Privacy Rights",
    component: <YourPrivacyRight />,
    id: "YourPrivacyRight",
  },
  {
    title: "4. What Kind Of Personal Data Do We Collect?",
    component: <KindOfPersonalData />,
    id: "KindOfPersonalData",
  },
  {
    title: "5. What is the Source of Personal Data We Collect?",
    component: <SourceOfPersonalData />,
    id: "SourceOfPersonalData",
  },
  {
    title: "6. Lawful Basis for Processing",
    component: <LawfulBasis />,
    id: "LawfulBasis",
  },
  {
    title: "7. How Do We Use Your Personal Data?",
    component: <UseYourPersonalData />,
    id: "UseYourPersonalData",
  },
  {
    title: "8. Who We Share Your Personal Data with?",
    component: <ShareYourPersonalData />,
    id: "ShareYourPersonalData",
  },
  {
    title: "9. How Long We Retain Your Personal Data?",
    component: <RetainYourPersonalData />,
    id: "RetainYourPersonalData",
  },
  {
    title: "10. How Do We Secure and Store Personal Data?",
    component: <StorePersonalData />,
    id: "StorePersonalData",
  },
  {
    title: "11. Data Breach",
    component: <DataBreach />,
    id: "DataBreach",
  },
  {
    title: "12. Opt-Out & Unsubscribe",
    component: <Unsubscribe />,
    id: "Unsubscribe",
  },
  {
    title:
      "13. What Happens When You Provide Us With Information About Others?",
    component: <InformationAboutOthers />,
    id: "InformationAboutOthers",
  },
];

const PrivacyBody = () => {
  const [contentDropdown, setContentDropdown] = useState(false);
  const [currentSection, setCurrentSection] = useState({ ...contentList[0] });

  let sectionRefs = useRef([]);
  sectionRefs.current = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(
    (ref, index) => (sectionRefs.current[index] = React.createRef())
  );

  // Intersection Observer callback
  const handleIntersection = (entries) => {
    entries.forEach((entry, index) => {
      if (entry.isIntersecting) {
        let currentSection = contentList.find(
          (item) => item.id === entry.target.id
        );
        setCurrentSection(currentSection);
        // Do something with the in-view section, e.g., highlight it
      }
    });
  };

  // Initialize Intersection Observer
  useEffect(() => {
    const options = {
      root: null, // viewport
      rootMargin: "0px",
      threshold: 0.2, // Trigger when at least 50% of the section is in the viewport
    };

    const observer = new IntersectionObserver(handleIntersection, options);

    sectionRefs.current.forEach((ref, index) => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });

    // Cleanup
    return () => {
      sectionRefs.current.forEach((ref, index) => {
        if (ref.current) {
          observer.unobserve(ref.current);
        }
      });
    };
  }, []);

  const presentCountry = useSelector((state) => state.geoDetails.country);
  let phone;
  switch (presentCountry) {
    case "Nigeria":
      phone = (
        <>
          Phone:
          <a
            href="tel:+2349131055072"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-4"
          >
            {" "}
            +234 913 105 5071.
          </a>
        </>
      );
      break;
    case "Ghana":
      phone = (
        <>
          Phone:
          <a
            href="tel:+233257115559"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-4"
          >
            {" "}
            +233 25 711 5559
          </a>
        </>
      );
      break;
    case "Kenya":
      phone = (
        <>
          Phone:
          <a
            href="tel:+254757436731"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-4"
          >
            {" "}
            +254 757 436 731.
          </a>
        </>
      );
      break;
    default:
      phone = "";
      break;
  }

  return (
    <>
      <div className="container mx-auto xl:py-[96px]">
        <div className="bg-[#F8F8F7] sticky lg:hidden top-[10vh] p-4 text-green-500  ">
          <div
            className="flex items-center justify-between gap-4 cursor-pointer"
            onClick={() => {
              setContentDropdown(!contentDropdown);
            }}
          >
            <p className="font-medium flex-1 text-sm">{currentSection.title}</p>
            {contentDropdown ? (
              <CaretUp weight="bold" />
            ) : (
              <CaretDown weight="bold" />
            )}
          </div>
          <AnimatePresence initial="false">
            {contentDropdown ? (
              <div className="space-y-2 max-h-[250px] overflow-y-scroll absolute top-full bg-white left-0 p-4 rounded-b-xl lift">
                {contentList.map((item, index) => {
                  return (
                    <p
                      href={`#${item.id}`}
                      className={`py-2 px-4 rounded-full text-sm font-inter block ${
                        item.title === currentSection.title
                          ? "bg-light-green-500 font-semibold"
                          : ""
                      }`}
                      onClick={(e) => {
                        setContentDropdown(!contentDropdown);
                        setCurrentSection(item);
                        const targetId = e.target
                          .getAttribute("href")
                          .substring(1);
                        const targetElement = document.getElementById(targetId);

                        if (targetElement) {
                          const offset =
                            targetElement.getBoundingClientRect().top +
                            window.scrollY -
                            window.innerHeight / 5;
                          window.scrollTo({
                            top: offset,
                            behavior: "smooth",
                          });
                        }
                      }}
                    >
                      {item.title}
                    </p>
                  );
                })}
              </div>
            ) : null}
          </AnimatePresence>
        </div>

        <div className="flex gap-10">
          <div className="space-y-2.5 w-[30%] max-w-[422px] self-start sticky top-[12vh] overflow-y-scroll  bg-white left-0 p-4 rounded-b-xl h-[85vh] hidden lg:block">
            {contentList.map((item, index) => {
              return (
                <p
                  href={`#${item.id}`}
                  className={`py-4 px-[30px] rounded-full text-sm font-inter block ${
                    item.title === currentSection.title
                      ? "bg-light-green-500 font-semibold"
                      : "bg-grey-50"
                  } cursor-pointer font-medium text-green-500`}
                  onClick={(e) => {
                    setContentDropdown(!contentDropdown);
                    setCurrentSection(item);
                    const targetId = e.target.getAttribute("href").substring(1);
                    const targetElement = document.getElementById(targetId);

                    if (targetElement) {
                      const offset =
                        targetElement.getBoundingClientRect().top +
                        window.scrollY -
                        window.innerHeight / 5;
                      window.scrollTo({
                        top: offset,
                        behavior: "smooth",
                      });
                    }
                  }}
                >
                  {item.title}
                </p>
              );
            })}
          </div>

          <div className="space-y-6 p-4 scroll-smooth flex-1 ">
            {contentList.map((item, index) => {
              return (
                <div
                  ref={sectionRefs.current[index]}
                  className=""
                  id={item.id}
                  key={index}
                >
                  {item.component}
                </div>
              );
            })}
            <p className="text-black text-sm leading-[26px] md:text-base lg:text-lg font-normal font-inter lg:leading-[30px]">
              For general enquiries regarding this Privacy Statement, or to make
              a request or complain about how We process Personal Data, You may
              contact Us at:
              <br />
              {/* <ul className="list-disc list-outside px">
                <li>
                <span className="text-light-purple-700 font-inter font-medium   underline-offset-4 leading-[18px] ">Address:</span>
               1st Floor, Dulux Building KM 18, Lekki-Ajah Expressway,
              Lekki Lagos, Nigeria
                </li>
              </ul> */}
              {/* <br /> */}
              <span className="text-light-purple-700   underline-offset-4 leading-[18px] ">
                Email:
              </span>
              <a
                href="mailto:info@venco.africa"
                target="_blank"
                rel="noopener noreferrer"
                className="underline underline-offset-4"
              >
                {" "}
                info@venco.africa
              </a>{" "}
              <br />
              {phone}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyBody;
